module.exports = __webpack_public_path__ + "img/icon_external.309bfe96.svg";